(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-conversion"] && !Shopify.designMode) return;
  try {
    
function initProductLanding(root) {
  root.querySelectorAll('.lp-thumbnail').forEach(function(button) {
    if (button.dataset.ready) return;
    button.dataset.ready = '1';
    button.addEventListener('click', function() {
      var img = root.querySelector('.lp-main-image');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = button.dataset.lpImage;
      img.alt = button.dataset.lpAlt;
      root.querySelectorAll('.lp-thumbnail').forEach(function(other) {
        other.classList.remove('is-selected');
        other.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
    });
  });
  root.querySelectorAll('[data-lp-qty]').forEach(function(button) {
    if (button.dataset.ready) return;
    button.dataset.ready = '1';
    button.addEventListener('click', function() {
      var input = root.querySelector('input[name="quantity"]');
      input.value = Math.max(1, (Number(input.value) || 1) + Number(button.dataset.lpQty));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
  });
}
document.querySelectorAll('.lp-core').forEach(initProductLanding);
document.addEventListener('shopify:section:load', function(event) {
  event.target.querySelectorAll('.lp-core').forEach(initProductLanding);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing"] && !Shopify.designMode) return;
  try {
    
function initProductLanding(root) {
  root.querySelectorAll('.lp-thumbnail').forEach(function(button) {
    if (button.dataset.ready) return;
    button.dataset.ready = '1';
    button.addEventListener('click', function() {
      var img = root.querySelector('.lp-main-image');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = button.dataset.lpImage;
      img.alt = button.dataset.lpAlt;
      root.querySelectorAll('.lp-thumbnail').forEach(function(other) {
        other.classList.remove('is-selected');
        other.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
    });
  });
  root.querySelectorAll('[data-lp-qty]').forEach(function(button) {
    if (button.dataset.ready) return;
    button.dataset.ready = '1';
    button.addEventListener('click', function() {
      var input = root.querySelector('input[name="quantity"]');
      input.value = Math.max(1, (Number(input.value) || 1) + Number(button.dataset.lpQty));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
  });
}
document.querySelectorAll('.lp-core').forEach(initProductLanding);
document.addEventListener('shopify:section:load', function(event) {
  event.target.querySelectorAll('.lp-core').forEach(initProductLanding);
});

  } catch(e) { console.error(e); }
})();
})();
